import { useQuery } from '@tanstack/react-query';
import { certificateService } from '../services/certificate.service';
import type { CandidateCertificate } from '../types/certificate.types';

export interface UseCandidateCertificateResult {
  certificate: CandidateCertificate | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export function useCandidateCertificate(shareId: string): UseCandidateCertificateResult {
  const query = useQuery({
    queryKey: ['candidate-certificate', shareId],
    queryFn: () => certificateService.getByShareId(shareId),
    enabled: !!shareId,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });

  return {
    certificate: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
